const FB_EVENT_NAME = "onFacebookEvent";
export default class Fbevents {
    constructor(element) {
        this.$element = $(element);
    }

    init() {
        this.$element.click(function (e) {
            if(!e.currentTarget.__FBeventTriggered) {
                e.currentTarget.__FBeventTriggered = true;
                var fbEventParams = $( e.currentTarget ).attr( "data-fbevent" );
                var eventFB = new CustomEvent(FB_EVENT_NAME, {
                    detail: { fbEventParams }
                });
                window.dispatchEvent(eventFB);
            }
        })
    }
}
